import {Utils} from "../utils";
import {DocumentData, QueryDocumentSnapshot} from "@angular/fire/firestore";
import "reflect-metadata";
import {Maintenance} from "./maintenance";

/*export function FirestoreRoot(path: string) {
  return function (target) {
    Object.defineProperty(target, 'firestoreRoot', {
      value: path,
    });
    return target;
  }
}*/

/*export function FirestoreCollection(a: any) {
  return function (target, propertyName) {
    console.log(a, target, propertyName);
    Object.defineProperty(a, 'collections', {
      writable: true,
      value: Object.assign((a.collections ? a.collections : {}), { [propertyName]: {} }),
      // value: (target.collections ? target.collections : []).concat({ [propertyName]: 'asd' }),
    });
  }
}*/

export class BaseModel {

  protected static self;

  public id: string;

  public static fromJson<T>(json: Object) {
    const data = Object.assign(new this, { ...json });
    Object.keys(data).forEach(key => {
      const model = (new this)[key];
      if (model instanceof BaseModel) {
        const classConstructor = model.constructor;
        if (data[key]) {
          // @ts-ignore
          data[key] = classConstructor.fromJson(data[key]);
        }
      }
    });
    return data;
  }

  public static fromJsonOld(firebaseDocument: QueryDocumentSnapshot<DocumentData>, isProcedure: boolean = false) {
    return Object.assign(new this.self, isProcedure ? this.mapToArray(Utils.uidInjector(firebaseDocument)) : Utils.uidInjector(firebaseDocument));
  }

  // Middleware to convert task and steps from map to array
  private static mapToArray(firebaseDocumentWithId: any) {
    if (firebaseDocumentWithId['tasks'] != null) {
      firebaseDocumentWithId['tasks'] = Object.values(firebaseDocumentWithId['tasks']).map(task => {
        task['steps'] = Object.values(task['steps']);
        return task;
      });
    }
    return firebaseDocumentWithId;
  }

  // Middleware to convert task and steps from map to array
  private arrayToMap(data: any) {
    if (data['tasks'] != null) {

      // Set tasks

      const tasks = {};

      data['tasks'].forEach(task => {

        const taskId = Utils.randomString(5);

        // Set steps
        const steps = {};
        task['steps'].forEach(step => {

          const stepId = Utils.randomString(5);
          step['order'] = Object.keys(steps).length;
          steps[stepId] = step;

        });
        task['steps'] = steps;


        task['order'] = Object.keys(tasks).length;
        tasks[taskId] = task;

      });

      data['tasks'] = tasks;
    }
    return data;
  }

  public toJson(isProcedure: boolean = false): Object {

    delete this.id;

    let data = JSON.parse(JSON.stringify(this));

    if (isProcedure) {
      data = this.arrayToMap(data);
    }

    // Avoid save other firestore collections as an object in parent document
    if (this.constructor['collections']) {
      Object.keys(this).forEach(property => {

        // If property is a firestore collection
        if (this.constructor['collections'].indexOf(property) >= 0) {
          delete this[property];
        }

      });
    }

    return data;
  }

}
